import { isFeatureEnabled } from 'owa-feature-flags';
import getStore from '../store';

export default function isLoadingProjects() {
    return getStore().isLoadingProjects || isFeatureEnabled('cal-board-dev-forceProjectsLoading');
}
